<template>
  <v-dialog v-model="dialog" persistent max-width="600px" content-class="configuration-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <ExecutionResultsDialog title="Auto-Assign" @close="close()" :shouldClose="!submitOptions.isTestRun" ref="executionResultsDialog" />
    <template v-slot:activator="{ on }">
      <v-btn :disabled="selectionCounter == 0" v-on="on" class="info">
        <v-icon class="mr-2">add_location_alt</v-icon>
        <div class="text-capitalize">Auto-Assign..</div>
      </v-btn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Auto-Assign Data Sources</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card>
          <v-alert color="warning" icon="warning" class="ma-0 pa-2" outline :value="hasMonitoringFeature">
            <div class="primary--text">One or more of the selected Data Sources are already assigned to a location and
              will not be affected.</div>
          </v-alert>

          <v-card-text class="py-3">
            <p>
              The <strong>{{ selectionCounter }}</strong> selected data sources will be assigned to locations that match
              their primary name or
              one of their assigned aliases.
            </p>
            <p>
              <strong>Note:</strong> Only data sources that have not yet been assigned are affected.
            </p>
            <p>If a location does not match these names, you may choose to create new locations based on the primary
              names.</p>
            <v-checkbox color="info" class="mt-0" v-model="submitOptions.createNewLocations" label="Create new locations" persistent-hint hint="If a matching location is not found, create a new location based on the primary name of the data source" />
            <v-checkbox color="error" class="mt-0" v-model="submitOptions.isTestRun" label="Test run" persistent-hint hint="Shows the outcome, but changes are not saved" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <v-spacer />
            <v-btn :loading="loading.submit" @click="submit()" color="success">
              <v-icon left>add_location_alt</v-icon>Auto-Assign
            </v-btn>
            <v-btn color="secondary" outline @click="close()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const dataSources = createNamespacedHelpers('datasource')
  const app = createNamespacedHelpers('app')

  export default {
    props: {
      selected: Object,
      selectionCounter: Number,
      items: Array,
    },
    data: () => ({
      dialog: false,
      loading: {
        submit: false,
      },
      submitOptions: {
        createNewLocations: false,
        isTestRun: true,
      },
    }),
    computed: {
      selectedItems() {
        if (!this.items) return []
        return this.items.filter(item => this.selected[item.id])
      },
      hasMonitoringFeature() {
        return !this.selectedItems.every(item => !item.MonitoringFeatureId)
      },
    },
    methods: {
      ...dataSources.mapActions(['autoAssignDataSources']),
      ...app.mapActions(['setSnackbar', 'refreshData']),
      async submit() {
        this.loading.submit = true

        try {
          let dataSources = this.selectedItems.map(ds => ({
            MonitoringFeatureId: ds.MonitoringFeatureId,
            SourceId: ds.sourceId,
            SourceType: ds.sourceType,
          }))

          var executionResults = await this.autoAssignDataSources({
            ...this.submitOptions,
            dataSources,
          })

          this.refresh()
          this.$refs.executionResultsDialog.show(executionResults)

        } catch (error) {
          console.error(error)
          this.$refs.executionResultsDialog.show(error)
        }

        this.loading.submit = false
      },
      async close() {
        this.dialog = false
      },
      async refresh() {
        this.loading.submit = true
        await this.refreshData({ monitoringFeatures: true })
        this.loading.submit = false
      },
    },
  }
</script>